import { Component, Input } from "@angular/core";

@Component({
    selector: "app-ai-chat-button",
    templateUrl: "./ai-chat-button.component.html",
    styleUrls: ["./ai-chat-button.component.scss"],
    standalone: false
})
export class AiChatButtonComponent{    
    @Input() aiChatUrl: string = "";

    openAiChat(): void {        
        if (this.aiChatUrl) {
            window.open(this.aiChatUrl, "_blank");
        } else {
            console.error("AI Chat URL is not defined.");
        }
    }
}